import React from 'react'
import PeopleDetailFlyout from 'src/app/PeopleDetailFlyout/PeopleDetailFlyout'
import { SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import PeopleInvitedToOrgAppRoute from 'src/navigation/appRoutes/people/peopleInvitedToOrg.appRoute'
import PeopleMembersAppRoute from 'src/navigation/appRoutes/people/peopleMembers.appRoute'
import { peopleMembersDetailRouteProps } from 'src/navigation/routeProps'

import { AppLocation } from '../appLocations'

const PeopleMembersDetailAppRoute: AppRoute = {
  id: AppLocation.PeopleMembersDetail,
  routeProps: peopleMembersDetailRouteProps,
  component: <PeopleDetailFlyout />,
  subRoutes: [],
  exceptions: [PeopleMembersAppRoute, PeopleInvitedToOrgAppRoute],
  meta: { contentType: SidenavContentType.Main },
}

export default PeopleMembersDetailAppRoute
